import {MemberDirectReducerState} from './app.interface';

export const memberDirectInitialState: MemberDirectReducerState = {
    errorText: null
};
